import styled, { css } from "styled-components";

export const Container = styled.div`
  height: 72px;
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: ${({theme, $isCreators}) => (
    $isCreators ? theme.old.colors.gray[800] : '#27272A'
  )};
  padding: 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  white-space: nowrap;
  
  ${({ theme, $isCreators }) => {
    if ($isCreators) return
    
    return css`
      ${theme.old.breakpoints.isTab} {
        border-radius: 8px;
        margin-bottom: 32px;
      }
    `
  }}
`

export const Name = styled.p`
  font-size:  ${({theme}) => theme.old.fonts.size.small};
  font-weight: ${({theme}) => theme.old.fonts.weight.semibold};

  ${({ theme, $isCreators }) => {
    if ($isCreators) return
    
    return css`
      ${theme.old.breakpoints.isTab} {
        font-size:  ${({theme}) => theme.old.fonts.size.normal};
    font-weight: ${({theme}) => theme.old.fonts.weight.semibold};
      }
    `
  }}
`
